import { createReducer, on } from '@ngrx/store';
import { setChartData, setChartSeries, } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
export const chartData = createReducer({}, on(setChartData, (state, action) => {
    return action.chartData;
}), on(setChartSeries, (state, action) => {
    return { ...state, chart_data: [action.series] };
}));
